import { render } from "./settings-page.vue?vue&type=template&id=333fd264&scoped=true"
import script from "./settings-page.vue?vue&type=script&lang=js"
export * from "./settings-page.vue?vue&type=script&lang=js"

import "./settings-page.vue?vue&type=style&index=0&id=333fd264&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333fd264"]])

export default __exports__